var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.3094 12.1746L1.859 3.1665H14.1411L13.6907 12.1746C13.5975 14.0373 12.0601 15.4998 10.195 15.4998H5.80504C3.93998 15.4998 2.40254 14.0374 2.3094 12.1746Z",
    stroke: "#9EAEBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M5.16663 3.5H10.8333V3C10.8333 1.61929 9.714 0.5 8.33329 0.5H7.66662C6.28591 0.5 5.16663 1.61929 5.16663 3V3.5Z",
    stroke: "#9EAEBA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 3.3335H15.3333",
    stroke: "#9EAEBA",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.3335V10.6668",
    stroke: "#9EAEBA",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.3335V10.6668",
    stroke: "#9EAEBA",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e5dc00c1eb7fecab64b057b13022b875.svg";
export { ForwardRef as ReactComponent };